// Module
var code = "<h2 id=\"confirm-your-action\">Confirm your action!</h2> <p>Before proceeding, please note that your webhook will be permanently deleted and this action is not reversible. You may want to disable it instead.</p> ";
// Exports
module.exports = code;